/** Invalidate old responses on cancellation, navigation or household changes. */
export function createCopilotRequestGate() {
    let generation = 0;
    return {
        begin: () => ++generation,
        invalidate: () => {
            generation++;
        },
        accepts: (ticket: number) => ticket === generation,
    };
}
